import PhotoSwipe from 'photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';

/**
 * PDP-photo-swipe popups
 *
 * @param {}
 * @return {void}
 */

const pswpElement = document.querySelectorAll('.pswp')[0];

// build items array
const imagesArray = [];
const $imagesHolder = $('.js-pswp-zoom');
const $images = $imagesHolder.find('.js-pswp-zoom-item');

for (let i = 0; i < $images.length; i++) {
  let imageWidth = $($images[i]).data('pswp-width');
  let imageSrc = $($images[i]).data('zoom');

  let image = {
    src: '',
    w: 600,
    h: 600
  }

  image.src = imageSrc;
  image.w = imageWidth;
  image.h = imageWidth;
  imagesArray.push(image);
}

// define options
let options = {
  index: 3,
  closeOnScroll: false,
  history: false,
  showHideOpacity: true,
  pinchToClose: false,
  maxSpreadZoom: true,
  showAnimationDuration: false,
  allowPanToNext: false,
  closeOnVerticalDrag: false
};

// Initializes and opens PhotoSwipe
$(document).on('click', '.js-zoom-image > a', function(e) {
  e.preventDefault();

  if ($(window).outerWidth() < 1024) {
    const $this = $(this);
    const imageIndex = $this.closest('.slick-slide').data('slick-index');

    options.index = imageIndex;

    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, imagesArray, options);
    gallery.init();
  }
});
